module.exports = __webpack_public_path__ + "static/media/a7.d377f106.png";